module.exports = __webpack_public_path__ + "static/group-2-0c81c0d2da55c43e6c646135a7e036c5.jpg";